import { Link } from "react-router-dom";
import logo from "@/assets/sortiven-logo.png";

export default function NotFound() {
  return (
    <div data-theme="institutional" className="flex min-h-screen items-center justify-center bg-background px-4" data-testid="not-found-page">
      <div className="text-center">
        <img src={logo} alt="SORTIVEN" className="mx-auto h-14 w-auto" />
        <h1 className="mt-6 text-2xl font-semibold text-foreground">Página no encontrada</h1>
        <p className="mt-2 text-sm text-muted-foreground">La dirección solicitada no existe.</p>
        <Link to="/" className="mt-4 inline-block text-sm text-primary hover:underline" data-testid="not-found-home-link">
          ← Volver al sitio público
        </Link>
      </div>
    </div>
  );
}
